import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ContextualField, PropertyType, Group } from '../../../models/index';
import { ApprovalTableConfiguration } from '../approvalTable.configuration';
import { DateFormat } from '../../../common/helpers/contextual';
import { guidEmpty } from '../../../common/';

class ApprovalTableContextualController implements angular.IComponentController {

    configuration: ApprovalTableConfiguration;
    formController: angular.IFormController;
    properties: ContextualField[];
    groups: Group[];
    approvableGroups: Group[];
    isBindable: boolean;

    save: () => void;
    cancel: () => void;

    private _originalConfiguration: ApprovalTableConfiguration;

    static $inject = ['$q'];
    constructor(private _$q: angular.IQService) {
    }

    $onInit() {
        this.properties = [
            {
                modelName: 'isTimestampVisible',
                propertyType: PropertyType.Boolean,
                label: 'Date',
                placeholder: 'Date',
                propertyName: 'isTimestampVisibleProperty',
                required: false,
                icon: 'fa-calendar-o'
            },
            {
                modelName: 'isApprovedDateVisible',
                propertyType: PropertyType.Boolean,
                label: 'Approval timestamp',
                placeholder: 'Approval timestamp',
                propertyName: 'isApprovedDateVisibleProperty',
                required: false,
                icon: 'fa-calendar-check-o'
            },
            {
                modelName: 'isUserVisible',
                propertyType: PropertyType.Boolean,
                label: 'User',
                placeholder: 'User',
                propertyName: 'isUserVisibleProperty',
                required: false,
                icon: 'fa-user'
            },
            {
                modelName: 'isCommentVisible',
                propertyType: PropertyType.Boolean,
                label: 'Justification',
                placeholder: 'Justification',
                propertyName: 'isCommentVisibleProperty',
                required: false,
                icon: 'fa-commenting'
            },
            angular.copy(DateFormat),
            {
                modelName: 'groupGuid',
                propertyType: PropertyType.Group,
                label: 'Group',
                placeholder: 'Group',
                propertyName: 'groupGuidProperty',
                required: true,
                icon: 'fa-sitemap',
                extraData: {
                    groups: this.groups?.filter(g => g.approvalStrategyGuid !== guidEmpty)
                },
                messages: [
                    { key: 'required', value: 'A group is required' },
                ]
            },
            {
                modelName: 'isBoundToGroup',
                propertyType: PropertyType.Boolean,
                label: 'Bind',
                placeholder: 'Bind',
                propertyName: 'isBoundToGroupProperty',
                required: false,
                icon: 'fa-anchor',
                hide: !this.isBindable,
                extraData: {
                }
            }
        ];
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['configuration']) {
            this._originalConfiguration = angular.copy(this.configuration);
        }
        if (changesObj['groups']) {
            const approvableGroups = this.groups?.filter(g => g.approvalStrategyGuid !== guidEmpty);
            if (this.properties) {
                const p = _.find(this.properties, p => p.modelName === 'groupGuid');
                if (p) {
                    p.extraData.groups = approvableGroups;
                }
            }
        }
        if (changesObj['isBindable']) {
            const p = _.find(this.properties, p => p.modelName === 'isBoundToGroup');
            if (p) {
                p.hide = !this.isBindable;
            }
        }
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }
}

export const wtApprovalTableContextual: ComponentDefinition = {
    componentId: 'wtApprovalTableContextual',
    controller: ApprovalTableContextualController,
    template: require('./approvalTableContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        configuration: '<',
        formController: '=?',
        groups: '<',
        save: '&?',
        cancel: '&?',
        isBindable: '<?'
    }
};
